import { useContext } from "react";
import Tooltip from "components/Tooltip";
import { NotAssignedIcon, PendingAssignmentIcon } from "components/SVGs";
import { useHistory } from "react-router-dom";
import { MasterDataContext } from "contexts/MasterDataContext";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "app/hooks";
import {
  isRedirectingSet,
  pendingEvaluationTabOption,
  tabSet,
} from "features/evaluation";
import { IGrade, IOption } from "features/common/Interfaces";

interface IStudentScoreCellProps {
  student: { score: string; studentId: number };
  loId: string;
  gradeInfo: IGrade;
  classInfo: IOption;
}
function StudentScoreCell({
  student,
  loId,
  gradeInfo,
  classInfo,
}: IStudentScoreCellProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { logEvent } = useContext(MasterDataContext);
  const history = useHistory();

  const evaluateHandle = (stuId: number) => {
    logEvent("EvaluationBaselineClickToEvaluate", {
      ClassId: classInfo.value,
      ContentId: loId,
    });
    localStorage.setItem("grade-evaluation", JSON.stringify(gradeInfo));
    localStorage.setItem("class-evaluation", JSON.stringify(classInfo));
    localStorage.setItem("lo-evaluation", loId);
    localStorage.setItem("student-evaluation", `${stuId}`);
    dispatch(isRedirectingSet(true));
    dispatch(tabSet(pendingEvaluationTabOption));
    history.push(`/evaluation`);
  };

  const renderCell = (
    data: { score: string; studentId: number },
    clickHandler: (id: number) => void
  ) => {
    const { score, studentId } = data;
    const style = {
      color: "rgba(98, 195, 238, 1)",
      cursor: "pointer",
      textDecoration: "underline",
    };
    let cell;
    switch (score) {
      case "NotStarted":
        cell = (
          <Tooltip title={t("pending")}>
            <div>
              <PendingAssignmentIcon />
            </div>
          </Tooltip>
        );
        break;
      case null:
        cell = (
          <Tooltip title={t("notAssigned")}>
            <div>
              <NotAssignedIcon />
            </div>
          </Tooltip>
        );
        break;

      case "Evaluation_Pending":
        cell = (
          <span onClick={() => clickHandler(studentId)} style={style}>
            {t("Evaluate")}
          </span>
        );
        break;
      default:
        {
          const value = Number(score);
          cell = (
            <span
              style={{
                borderRadius: "50%",
                height: "15px",
                width: "15px",
                backgroundColor:
                  value === 0
                    ? "rgba(212, 78, 78, 1)"
                    : value === 100
                    ? "rgb(134, 189, 48)"
                    : "rgba(250, 150, 69, 1)",
                position: "absolute",
              }}
            ></span>
          );
        }
        break;
    }

    return cell;
  };
  return renderCell(student, evaluateHandle);
}

export default StudentScoreCell;
